import { GlobalContext } from 'Context/GlobalContext/AppContext';
import DetailPage from 'pages/detail';
import EditPage from 'pages/edit';
import LoginPage from 'pages/login';
import NotFound from 'pages/notFound';
import SavePage from 'pages/save';
import SearchPage from 'pages/search';
import { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router';

function CustomRoute({ isPrivate, ...rest }) {
  const { user } = useContext(GlobalContext);

  if (isPrivate && !user.isAuthenticated) {
    return <Redirect to="/login" />;
  }

  return <Route {...rest} />;
}

const Routes = () => {
  return (
    <Switch>
      <CustomRoute exact path="/" children={<SearchPage />} />
      <CustomRoute path="/login" children={<LoginPage />} />
      <CustomRoute isPrivate path="/Novo/:tipoDoc" children={<SavePage />} />
      <CustomRoute isPrivate path="/:tipoDoc/Editar/:id" children={<EditPage />} />
      <CustomRoute isPrivate path="/:tipoDoc/Editar/:id" children={<EditPage />} />
      <CustomRoute path="/:tipoDoc/Detalhe/:id" children={<DetailPage />} />
      <CustomRoute path="/:tipoDoc/Detalhe/:id" children={<DetailPage />} />
      <CustomRoute path="/*" children={<NotFound />} />
    </Switch>
  );
};

export default Routes;
